import {createContext, useEffect, useState, useCallback} from "react";
import Sidebar, {SidebarTab} from "../../components/Sidebar";
import TechnologiesMap from "../../components/TechnologiesMap";
import {
  initialStateInitiativeDataIds,
  initialStateInitiativeFilters,
} from "./StateInitiative.const";
import {DashboardContainer, TopBarContainer} from "./StateInitiative.styles";
import {
  IPeople,
  IPrevPeople,
  IStateInitiativeDataIds,
  IOrganizationSegment,
  IOrganization,
  IDistributedOrganization,
} from "./StateInitiative.type";
import SidebarCard from "../../components/SidebarCard";
import {
  IOrganizationFromSegment,
  IAuthoritiesFromSegmentsResponse,
} from "../../hooks/useFetchDataCrgciAuthorities";
import useFetchDataCrgciAuthorities from "../../hooks/useFetchDataCrgciAuthorities";
import {apiKeyDataCRGCI, urlApiDataCRGCI} from "../../helper/api";
import SidebarInfo from "../../components/SidebarInfo";
import {IDataForSearchSidebar, ITypeRadar} from "../../types";
import {SidebarCardContainer} from "../../ui/SidebarCardContainer";
import {AboutRadarTop} from "../../components/AboutRadarTop/AboutRadarTop";
import {SidebarCardStackHolders} from "../../components/SidebarCard/SidebarCardStackHolders";
import {SidebarCardCrgci} from "../../components/SidebarCard/SidebarCardCrgci";
import {SidebarCardWorkerNew} from "../../components/SidebarCard/SidebarCardWorkerNew";
import useFetchDataCrgciWorker from "../../hooks/useFetchDataCrgciWorker";
// import {RadarChartStateOrganisationsNew} from "../../components/RadarChart/RadarCgartStateOrganisations2";
import {RadarChartStateOrganisations} from "../../components/RadarChart/RadarCgartStateOrganisations";

import {useNavigationBlocks} from "../../hooks/useNavigationBlocks";
import {NavigationBlockType} from "../../types/NavigationBlocks";
import {
  createOrganisationBlock,
  createInitiativeBlock,
  createWorkerBlock,
  shouldShowOrganisationSidebar,
  shouldShowInitiativeView,
  shouldShowWorkerView,
  getBlockTitle,
} from "../../utils/navigationBlockUtils";

export const DataStateInitiativeIdsContext = createContext<any>(null);

const StateOrganisationsDashboard = () => {
  const [activeSidebarTab, setActiveSidebarTab] = useState<SidebarTab>(
    SidebarTab.Empty
  );

  const [dataIds, setDataIds] = useState<IStateInitiativeDataIds>(
    initialStateInitiativeDataIds
  );

  const [isLogin, setIsLogin] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  const [isVisibleFiltersPanel, setIsVisibleFiltersPanel] = useState(false);

  if (!apiKeyDataCRGCI) {
    throw new Error("CRGCI API key не найден");
  }

  const {authoritiesData} = useFetchDataCrgciAuthorities(
    urlApiDataCRGCI,
    apiKeyDataCRGCI
  );

  const authorities: IOrganizationFromSegment[] | undefined =
    authoritiesData?.data;

  const radarSectors = [
    {name: "Органы власти", color: "#4ECDC4", angle: -45}, // сектор 0: от -90 до 0 (верх)
    {name: "Банк России", color: "#FF6B6B", angle: 45}, // сектор 1: от 0 до 90 (право)
    {name: "Ассоциации и площадки", color: "#96CEB4", angle: 135}, // сектор 2: от 90 до 180 (низ)
    {name: "Рынок", color: "#45B7D1", angle: 225},
  ];

  const distributeOrganizationsToSectors = (
    organizations: IOrganizationFromSegment[]
  ): IDistributedOrganization[] => {
    if (!organizations || organizations.length === 0) return [];

    const allOrganizations: IDistributedOrganization[] = [];

    const organizationsBySector = organizations.reduce((acc, org) => {
      const sectorName = org.segment;
      if (!acc[sectorName]) {
        acc[sectorName] = [];
      }
      acc[sectorName].push(org);
      return acc;
    }, {} as Record<string, IOrganizationFromSegment[]>);

    const commonRadius = 0.6;

    Object.entries(organizationsBySector).forEach(([sectorName, orgs]) => {
      const sector =
        radarSectors.find((s) => s.name === sectorName) || radarSectors[0];

      orgs.forEach((org, index) => {
        const totalOrgs = orgs.length;

        const angleRange = 85;
        const angleStep = angleRange / (totalOrgs + 1);
        const orgAngle =
          sector.angle - angleRange / 2 + angleStep * (index + 1);

        const radius = commonRadius;

        const x = radius * Math.cos((orgAngle * Math.PI) / 180);
        const y = radius * Math.sin((orgAngle * Math.PI) / 180);

        const initiativesCount = org.initiatives?.length || 0;

        allOrganizations.push({
          ...org,
          sector: sector.name,
          sectorColor: sector.color,
          segmentName: org.segment,
          x: x,
          y: y,
          radius: radius,
          angle: orgAngle,
          size: Math.max(0.03, 0.05 + initiativesCount * 0.01),
          initiativesCount: initiativesCount,
        });
      });
    });

    return allOrganizations;
  };
  const distributedAuthorities = authorities
    ? distributeOrganizationsToSectors(authorities)
    : [];

  const searchDatasidebarInfo = {
    directions: [],
    clusters: [],
  };

  const [isShowAllLabels, setIsShowAllLabels] = useState(true);
  const [isOpenPanel, setIsOpenPanel] = useState(false);
  const [isOpenSideBarInfo, setIsOpenSideBarInfo] = useState<boolean>(false);

  const [isOpenSideBarStackHolders, setIsOpenSideBarStackHolders] =
    useState<boolean>(false);

  const [activeWorkerOrg, setActiveWorkerOrg] = useState<IPeople | undefined>(
    undefined
  );

  const [radarWorkerData, setRadarWorkerData] = useState<any>(null);

  const handleWorkerDataChange = (workerData: any) => {
    setRadarWorkerData(workerData);

    if (workerData?.imageSrc && workerData?.documentId) {
      setUserSelectedWorkerPhoto(workerData.imageSrc);
      setUserSelectedWorkerDocumentId(workerData.documentId);
    }

    if (workerData && workerData.documentId) {
      const photoUrl = workerData.imageSrc
        ? workerData.imageSrc.replace(urlApiDataCRGCI || "", "")
        : activeWorker.photo?.formats?.thumbnail?.url;

      const newThumbnail = {
        ext: (activeWorker.photo?.formats?.thumbnail?.ext || null) as
          | string
          | null,
        hash: (activeWorker.photo?.formats?.thumbnail?.hash || null) as
          | string
          | null,
        height: (activeWorker.photo?.formats?.thumbnail?.height || null) as
          | number
          | null,
        mime: (activeWorker.photo?.formats?.thumbnail?.mime || null) as
          | string
          | null,
        name: (activeWorker.photo?.formats?.thumbnail?.name || null) as
          | string
          | null,
        path: (activeWorker.photo?.formats?.thumbnail?.path || null) as
          | string
          | null,
        size: (activeWorker.photo?.formats?.thumbnail?.size || null) as
          | number
          | null,
        sizeInBytes: (activeWorker.photo?.formats?.thumbnail?.sizeInBytes ||
          null) as number | null,
        url: photoUrl || null,
        width: (activeWorker.photo?.formats?.thumbnail?.width || null) as
          | number
          | null,
      };

      const updatedWorker = {
        ...activeWorker,
        ...workerData,
        photo:
          photoUrl && activeWorker.photo
            ? {
                ...activeWorker.photo,
                formats: activeWorker.photo.formats
                  ? {
                      ...activeWorker.photo.formats,
                      thumbnail: newThumbnail,
                    }
                  : {
                      large: newThumbnail,
                      medium: newThumbnail,
                      small: newThumbnail,
                      thumbnail: newThumbnail,
                    },
              }
            : activeWorker.photo,
      };

      setActiveWorker(updatedWorker);
    }

    const workerBlock = createWorkerBlock(
      workerData.documentId || workerData.id || "unknown",
      workerData.fullName || "Неизвестный сотрудник",
      workerData.role || workerData.jobFunction || "Не указано",
      {
        initiativeId: selectedInitiativeTitle || "",
        initiativeName: selectedInitiativeTitle || "",
        organisationId:
          savedOrganisationDataIds?.organizationData?.documentId || "",
        organisationName:
          savedOrganisationDataIds?.organizationData?.name ||
          savedOrganisationDataIds?.trendName ||
          "",
      },
      {workerData}
    );

    pushBlock(workerBlock);
  };

  const [isOpenOrganisationsRadar, setIsOpenOrganisationsRadar] =
    useState<boolean>(false);
  const [selectedInitiativeTitle, setSelectedInitiativeTitle] =
    useState<string>("");

  const [isOpenSideBar, setIsOpenSideBar] = useState<boolean>(false);
  const [isSearchPanelActive, setIsSearchPanelActive] = useState(false);
  const [filters, setFilters] = useState(initialStateInitiativeFilters);

  const [cpuStep, setCpuStep] = useState(1);
  const [activeTab, setActiveTab] = useState(SidebarTab.Empty);

  const [currentSector, setCurrentSector] = useState<string>("");

  const [savedOrganisationDataIds, setSavedOrganisationDataIds] =
    useState<IStateInitiativeDataIds | null>(null);

  const [savedFirstStepState, setSavedFirstStepState] = useState<{
    isOpenSideBar: boolean;
    activeSidebarTab: SidebarTab;
    dataIds: IStateInitiativeDataIds;
    currentSector?: string;
  } | null>(null);

  const [activeWorker, setActiveWorker] = useState({} as IPeople);
  const [arrPersonsWorker, setArrPersonsWorker] = useState([] as IPeople[]);
  const [idWorkerShowConnections, setIdWorkerShowConnections] = useState("");
  const [prevIdWorker, setPrevIdWorker] = useState<IPrevPeople[]>([]);
  const [userSelectedWorkerPhoto, setUserSelectedWorkerPhoto] = useState<
    string | null
  >(null);
  const [userSelectedWorkerDocumentId, setUserSelectedWorkerDocumentId] =
    useState<string | null>(null);

  const [isOpenWorkerRadar, setIsOpenWorkerRadar] = useState<boolean>(false);

  const navigationBlocks = useNavigationBlocks();
  const {pushBlock} = navigationBlocks;

  useEffect(() => {
    if (
      navigationBlocks.navigationStack.length === 0 &&
      authoritiesData?.data &&
      authoritiesData.data.length > 0
    ) {
      const initialBlock = createOrganisationBlock(
        "org-list",
        "Органы власти",
        "Органы власти",
        {
          activeSidebarTab: SidebarTab.StateOrganisations,
          dataIds: initialStateInitiativeDataIds,
          isOpenSideBar: true,
        }
      );

      navigationBlocks.pushBlock(initialBlock);
    }
  }, [authoritiesData?.data, navigationBlocks]);

  const manageSidebarStates = useCallback(
    (action: "openWorkerSidebars" | "openOrganisationRadar" | "closeAll") => {
      switch (action) {
        case "openWorkerSidebars":
          setPrevIdWorker([]);
          setIsOpenOrganisationsRadar(false);
          setIsOpenSideBarStackHolders(true);
          setIsOpenWorkerRadar(true);
          break;

        case "openOrganisationRadar":
          setIsOpenSideBarStackHolders(false);
          setIsOpenWorkerRadar(false);
          setIsOpenOrganisationsRadar(true);
          break;

        case "closeAll":
          setIsOpenOrganisationsRadar(false);
          setIsOpenSideBarStackHolders(false);
          setIsOpenWorkerRadar(false);
          break;
      }
    },
    []
  );

  const {
    personsConnections,
    arrSecondPersonsConnections,
    loading: workerLoading,
  } = useFetchDataCrgciWorker(idWorkerShowConnections || "");

  useEffect(() => {
    if (personsConnections?.data) {
      let updatedWorker = personsConnections.data;

      if (
        userSelectedWorkerPhoto &&
        userSelectedWorkerDocumentId &&
        updatedWorker.documentId === userSelectedWorkerDocumentId
      ) {
        const newThumbnail = {
          ext: (updatedWorker.photo?.formats?.thumbnail?.ext || null) as
            | string
            | null,
          hash: (updatedWorker.photo?.formats?.thumbnail?.hash || null) as
            | string
            | null,
          height: (updatedWorker.photo?.formats?.thumbnail?.height || null) as
            | number
            | null,
          mime: (updatedWorker.photo?.formats?.thumbnail?.mime || null) as
            | string
            | null,
          name: (updatedWorker.photo?.formats?.thumbnail?.name || null) as
            | string
            | null,
          path: (updatedWorker.photo?.formats?.thumbnail?.path || null) as
            | string
            | null,
          size: (updatedWorker.photo?.formats?.thumbnail?.size || null) as
            | number
            | null,
          sizeInBytes: (updatedWorker.photo?.formats?.thumbnail?.sizeInBytes ||
            null) as number | null,
          url: userSelectedWorkerPhoto.replace(urlApiDataCRGCI || "", ""),
          width: (updatedWorker.photo?.formats?.thumbnail?.width || null) as
            | number
            | null,
        };

        updatedWorker = {
          ...updatedWorker,
          photo: updatedWorker.photo
            ? {
                ...updatedWorker.photo,
                formats: updatedWorker.photo.formats
                  ? {
                      ...updatedWorker.photo.formats,
                      thumbnail: newThumbnail,
                    }
                  : {
                      large: newThumbnail,
                      medium: newThumbnail,
                      small: newThumbnail,
                      thumbnail: newThumbnail,
                    },
              }
            : null,
        };
      }

      setActiveWorker(updatedWorker);
    }

    setArrPersonsWorker(arrSecondPersonsConnections);
  }, [
    personsConnections,
    arrSecondPersonsConnections,
    userSelectedWorkerPhoto,
    userSelectedWorkerDocumentId,
    activeWorker.documentId,
  ]);

  const [previousWorkerId, setPreviousWorkerId] = useState<string>("");

  useEffect(() => {
    if (
      idWorkerShowConnections &&
      previousWorkerId &&
      idWorkerShowConnections !== previousWorkerId
    ) {
      setUserSelectedWorkerPhoto(null);
      setUserSelectedWorkerDocumentId(null);
    }

    setPreviousWorkerId(idWorkerShowConnections);
  }, [idWorkerShowConnections, previousWorkerId]);

  useEffect(() => {
    if (idWorkerShowConnections && activeWorker) {
      if (!isOpenSideBarStackHolders || !isOpenWorkerRadar) {
        manageSidebarStates("openWorkerSidebars");
      }
    }
  }, [
    idWorkerShowConnections,
    activeWorker,
    isOpenSideBarStackHolders,
    isOpenWorkerRadar,
    isOpenOrganisationsRadar,
    manageSidebarStates,
    navigationBlocks,
  ]);

  const resetRadarActiveSegmentRef = {current: null as (() => void) | null};

  useEffect(() => {
    if (activeSidebarTab === SidebarTab.Directions) {
      setActiveTab(SidebarTab.Directions);
    }
    if (activeSidebarTab === SidebarTab.Projects) {
      setActiveTab(SidebarTab.Directions);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.StateOrganisations) {
      setActiveTab(SidebarTab.StateOrganisations);
      setIsOpenSideBar(true);
      if (activeTab !== SidebarTab.StateOrganisations) {
        setIsOpenOrganisationsRadar(false);
        setSelectedInitiativeTitle("");
      }
    }
    if (activeSidebarTab === SidebarTab.CPU) {
      cpuStep === 1
        ? setActiveTab(SidebarTab.Projects)
        : setActiveTab(SidebarTab.CPU);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.Trends) {
      setActiveTab(SidebarTab.Trends);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.WeakSignal) {
      setActiveTab(SidebarTab.WeakSignal);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.StateInitiative) {
      setActiveTab(SidebarTab.StateInitiative);
      setIsOpenSideBar(true);
    }

    if (activeSidebarTab === SidebarTab.Empty) {
      setIsOpenOrganisationsRadar(false);
      setSelectedInitiativeTitle("");
    }
  }, [activeSidebarTab, cpuStep, activeTab]);

  const openSidebarWithTab = (
    tab: SidebarTab,
    directionId: number | string,
    trendId?: number | string,
    trendTitle?: string,
    sectionName?: string,
    segmentColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean
  ) => {
    setCpuStep(1);

    if (tab === SidebarTab.StateOrganisations) {
      setCurrentSector(sectionName || "Сектор");

      const serverOrgData = authorities?.find(
        (org) => org.id === directionId || org.documentId === directionId
      );

      const finalOrgData = serverOrgData || null;

      setDataIds({
        directionId: 1,
        trendId: directionId,
        trendName: trendTitle || "Организация",
        directionName: "Государственные организации",
        colorTitle: segmentColor?.back || "#3290B7",
        organizationData: finalOrgData,
        currentSector: sectionName || "Сектор",
      });
    } else {
      setDataIds({
        directionId,
        trendId: trendId !== undefined ? trendId : null,
        trendName: trendTitle || "",
        directionName: sectionName || "",
        colorTitle: segmentColor?.back || "#A774FF",
      });
    }
    setActiveSidebarTab(tab);
    setActiveTab(tab);
    setIsOpenPanel(false);
    if (isSearchPanelActive) {
      setIsSearchPanelActive(true);
    } else {
      setIsSearchPanelActive(false);
    }
    setIsOpenSideBarInfo(false);
    setIsOpenSideBar(true);
  };

  const resetToDefaultTab = () => {
    if (isSearchPanelActive) setIsOpenPanel(true);
    setTimeout(() => {
      setActiveSidebarTab(SidebarTab.Empty);
      setCpuStep(1);
    }, 600);
    setDataIds({
      directionId: null,
      trendId: null,
      trendName: "",
      directionName: "",
      colorTitle: "",
    });
    setIsOpenSideBar(false);
    setActiveTab(SidebarTab.Empty);
    setIsOpenSideBarStackHolders(false);
    setIsOpenSideBarInfo(false);
    setIsOpenOrganisationsRadar(false);
    setSelectedInitiativeTitle("");
    setActiveWorkerOrg(undefined);
    setIsOpenWorkerRadar(false);
  };

  const openOrganisationsRadar = (documentId: string) => {
    setIdWorkerShowConnections("");
    setActiveWorker({} as IPeople);
    setPrevIdWorker([]); // Очищаем историю работников при переходе к инициативе

    const stateToSave = {
      isOpenSideBar: isOpenSideBar,
      activeSidebarTab: activeSidebarTab,
      dataIds: dataIds,
      currentSector: currentSector,
    };

    setSavedFirstStepState(stateToSave);

    setSavedOrganisationDataIds(dataIds);

    setSelectedInitiativeTitle(documentId);
    manageSidebarStates("openOrganisationRadar");

    const newDataIds = {
      directionId: null,
      trendId: documentId,
      trendName: "Инициатива",
      directionName: "",
      colorTitle: "#3290B7",
    };
    setDataIds(newDataIds);

    const currentBlock = navigationBlocks.getCurrentBlock();
    if (currentBlock) {
      const initiativeBlock = createInitiativeBlock(
        documentId,
        "Инициатива",
        {
          organisationId: currentBlock.data?.organisationId,
          organisationName: currentBlock.data?.organisationName,
          currentSector: currentBlock.data?.currentSector,
        },
        {
          savedFirstStepState: stateToSave,
          savedOrganisationDataIds: dataIds,
          dataIds: newDataIds,
        }
      );
      navigationBlocks.pushBlock(initiativeBlock);
    }
  };
  const closeOrganisationsRadar = () => {
    setIsOpenOrganisationsRadar(false);
    setSelectedInitiativeTitle("");

    setDataIds(initialStateInitiativeDataIds);
  };

  const backToOrganisationSidebar = () => {
    setPrevIdWorker([]);

    const targetBlock =
      navigationBlocks.navigationStack.length > 1
        ? navigationBlocks.navigationStack[
            navigationBlocks.navigationStack.length - 2
          ]
        : null;

    navigationBlocks.popBlock();

    if (targetBlock && shouldShowOrganisationSidebar(targetBlock)) {
      if (targetBlock.data?.dataIds) {
        setDataIds(targetBlock.data.dataIds);
      }
      if (targetBlock.data?.currentSector) {
        setCurrentSector(targetBlock.data.currentSector);
      }
      if (targetBlock.data?.activeSidebarTab) {
        setActiveSidebarTab(targetBlock.data.activeSidebarTab as SidebarTab);
      }
    }

    manageSidebarStates("openOrganisationRadar");
    setSelectedInitiativeTitle("");

    setIdWorkerShowConnections("");
    setActiveWorker({} as IPeople);
    setArrPersonsWorker([]);
    setRadarWorkerData(null);

    if (savedFirstStepState) {
      setIsOpenSideBar(savedFirstStepState.isOpenSideBar);
      setActiveSidebarTab(savedFirstStepState.activeSidebarTab);
      setDataIds(savedFirstStepState.dataIds);
      if (savedFirstStepState.currentSector) {
        setCurrentSector(savedFirstStepState.currentSector);
      }
    } else {
      setIsOpenSideBar(true);
      setActiveSidebarTab(SidebarTab.StateOrganisations);
      if (savedOrganisationDataIds) {
        setDataIds(savedOrganisationDataIds);
      }
    }

    setSavedFirstStepState(null);
    setSavedOrganisationDataIds(null);
  };

  const closeSidebarOrganisations = () => {
    if (resetRadarActiveSegmentRef.current) {
      resetRadarActiveSegmentRef.current();
    }

    setActiveWorkerOrg(undefined);

    setIsOpenSideBar(false);
  };

  const openWorkerRadar = () => {
    setPrevIdWorker([]);
    setIsOpenWorkerRadar(true);
  };

  const closeWorkerRadar = () => {
    manageSidebarStates("closeAll");
  };

  const handleResetActiveSegmentReady = (resetFn: () => void) => {
    resetRadarActiveSegmentRef.current = resetFn;
  };
  const toggleFilter: <T>(
    filter?: string,
    value?: T,
    isReset?: boolean
  ) => void = (filter, value, isReset = false) => {
    if (isReset) {
      setFilters(initialStateInitiativeFilters);
      return;
    }
  };

  return (
    <DataStateInitiativeIdsContext.Provider value={{dataIds, setDataIds}}>
      <DashboardContainer>
        <Sidebar
          setIsLogin={setIsLogin}
          setRole={setRole}
          isLogin={isLogin}
          role={role}
          activeTab={activeTab}
          typeRadar="stateInitiative"
          setIsOpenSideBarInfo={setIsOpenSideBarInfo}
          isOpenSideBarInfo={isOpenSideBarInfo}
          isOpenSideBar={isOpenSideBar}
          searchDatasidebarInfo={searchDatasidebarInfo as IDataForSearchSidebar}
          setIsOpenPanel={setIsOpenPanel}
          isOpenPanel={isOpenPanel}
          openSidebarWithTab={openSidebarWithTab}
          onFilterChange={toggleFilter}
          filters={filters}
          isVisibleFiltersPanel={isVisibleFiltersPanel}
          setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
          isShowAllLabels={isShowAllLabels}
          setIsShowAllLabels={setIsShowAllLabels}
          setIsOpenSearchPanel={setIsOpenPanel}
          authorities={authorities}
          isActiveWorker={Object.keys(activeWorker || {}).length > 0}
          isOpenSideBarStackHolders={isOpenSideBarStackHolders}
          resetToDefaultTab={resetToDefaultTab}
        />

        <SidebarCardContainer isOpenSideBar={isOpenSideBar}>
          <SidebarCard
            isLogin={isLogin}
            role={role}
            activeTab={activeSidebarTab}
            resetToDefaultTab={resetToDefaultTab}
            setActiveTab={setActiveSidebarTab}
            cpuStep={cpuStep}
            setCpuStep={setCpuStep}
            typeRadar={"stateInitiative"}
            currentSector={currentSector}
            isOpenSideBarStackHolders={isOpenSideBarStackHolders}
            setIsOpenSideBarStackHolders={setIsOpenSideBarStackHolders}
            activeWorker={activeWorker}
            setActiveWorker={setActiveWorker}
            idWorkerShowConnections={idWorkerShowConnections}
            setIdWorkerShowConnections={setIdWorkerShowConnections}
            prevIdWorker={prevIdWorker}
            setPrevIdWorker={setPrevIdWorker}
            openOrganisationsRadar={openOrganisationsRadar}
            closeOrganisationsRadar={closeOrganisationsRadar}
            closeSidebarOrganisations={closeSidebarOrganisations}
            activeWorkerOrg={activeWorkerOrg}
            setActiveWorkerOrg={setActiveWorkerOrg}
            onWorkerDataChange={handleWorkerDataChange}
            // Блочная навигация
            navigationBlocks={navigationBlocks}
            backToOrganisationSidebar={backToOrganisationSidebar}
          />
        </SidebarCardContainer>

        <SidebarCardContainer isOpenSideBar={isOpenOrganisationsRadar}>
          {isOpenOrganisationsRadar && selectedInitiativeTitle && (
            <div style={{display: "flex", width: "100%", height: "100%"}}>
              <div style={{width: "600px", height: "100%"}}>
                <SidebarCard
                  isLogin={isLogin}
                  role={role}
                  activeTab={SidebarTab.StateInitiative}
                  resetToDefaultTab={closeSidebarOrganisations}
                  setActiveTab={setActiveTab}
                  cpuStep={cpuStep}
                  setCpuStep={setCpuStep}
                  typeRadar="stateInitiative"
                  documentId={selectedInitiativeTitle}
                  initiativesData={null}
                  currentSector={currentSector}
                  openOrganisationsRadar={openOrganisationsRadar}
                  closeOrganisationsRadar={closeOrganisationsRadar}
                  backToOrganisationSidebar={backToOrganisationSidebar}
                  closeSidebarOrganisations={closeSidebarOrganisations}
                  activeWorkerOrg={activeWorkerOrg}
                  setActiveWorkerOrg={setActiveWorkerOrg}
                  onWorkerDataChange={handleWorkerDataChange}
                  isFromOrganisationsPage={true}
                />
              </div>
              <SidebarCardCrgci
                onClose={closeOrganisationsRadar}
                documentId={selectedInitiativeTitle}
                arrPersonsWorker={arrPersonsWorker}
                setIdWorkerShowConnections={setIdWorkerShowConnections}
                prevIdWorker={prevIdWorker}
                setPrevIdWorker={setPrevIdWorker}
              />
            </div>
          )}
        </SidebarCardContainer>

        <SidebarCardContainer
          isOpenSideBar={isOpenSideBarStackHolders && !!activeWorker}
        >
          {isOpenSideBarStackHolders && activeWorker && (
            <SidebarCardWorkerNew
              isOpen={isOpenSideBarStackHolders}
              activeWorker={activeWorker}
              onClose={() => {
                manageSidebarStates("closeAll");
              }}
              onBack={backToOrganisationSidebar}
              arrPersonsWorker={arrPersonsWorker}
              setIdWorkerShowConnections={setIdWorkerShowConnections}
              prevIdWorker={prevIdWorker}
              setPrevIdWorker={setPrevIdWorker}
              openWorkerRadar={openWorkerRadar}
              openOrganisationsRadar={openOrganisationsRadar}
              onWorkerDataChange={handleWorkerDataChange}
              isLoading={workerLoading}
              isFromOrganisationsPage={true}
            />
          )}
        </SidebarCardContainer>

        <SidebarCardContainer isOpenSideBar={isOpenWorkerRadar}>
          {isOpenWorkerRadar && activeWorker && (
            <SidebarCardStackHolders
              isOpen={isOpenWorkerRadar}
              activeWorker={activeWorker}
              onClose={closeWorkerRadar}
              arrPersonsWorker={arrPersonsWorker}
              setIdWorkerShowConnections={setIdWorkerShowConnections}
              prevIdWorker={prevIdWorker}
              setPrevIdWorker={setPrevIdWorker}
            />
          )}
        </SidebarCardContainer>

        <SidebarCardContainer isOpenSideBar={isOpenSideBarInfo}>
          <SidebarInfo
            typeRadar="stateInitiative"
            close={setIsOpenSideBarInfo}
          />
        </SidebarCardContainer>

        <TopBarContainer>
          <AboutRadarTop typeRadar={"stateInitiative"} />
          <TechnologiesMap
            typeRadar={"crgci_organizations"}
            isLogin={isLogin}
          />
        </TopBarContainer>

        <RadarChartStateOrganisations
          openSidebarWithTab={openSidebarWithTab}
          onResetActiveSegmentReady={handleResetActiveSegmentReady}
          selectedWorkerData={radarWorkerData}
          authoritiesRadarData={distributedAuthorities}
          radarSectors={radarSectors}
        />
      </DashboardContainer>
    </DataStateInitiativeIdsContext.Provider>
  );
};

export default StateOrganisationsDashboard;
